import { ComponentChildren } from "preact"
import { Sidebar } from "@/app/sidebar"
import { ArrowLeftIcon } from "@heroicons/react/24/outline"
import { useLocation } from "wouter-preact"

export function BackToSettingsButton() {
  const [, setLocation] = useLocation()

  return (
    <div class="mb-6">
      <button
        type="button"
        onClick={() => setLocation("/settings/connections")}
        class="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition-colors">
        <ArrowLeftIcon class="h-4 w-4" />
        <span>Back to Settings</span>
      </button>
    </div>
  )
}

interface SettingsConnectLayoutProps {
  children: ComponentChildren
}

export function SettingsConnectLayout({ children }: SettingsConnectLayoutProps) {
  return (
    <div class="flex min-h-screen">
      <Sidebar />
      <div class="min-w-0 flex-1 relative">
        <div class="absolute top-6 left-6 z-10">
          <BackToSettingsButton />
        </div>
        {children}
      </div>
    </div>
  )
}
